export let regex = {
    singleLinePlainText: /^[\w\-_ ]*$/,
    plainText: /^[\w\-_\s]*$/,
    docId: /^[a-z0-9]+$/i,//"^(?!\.\.?$)(?!.*__.*__)([^/]{1,1500})$",
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,// /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
}